import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Groupement, User } from './types/user';

type UserState = User & { logoUrl?: string };

const userSlice = createSlice({
    name: 'user',
    initialState: null as UserState | null,
    reducers: {
        logout: () => null,
        setUser: (_, action: PayloadAction<UserState>) => action.payload,
        setAutoPubNf: (state, action: PayloadAction<boolean>) =>
            state ? { ...state, autoPublish: action.payload } : state,
        setLogoDisplay: (state, action: PayloadAction<boolean>) =>
            state ? { ...state, displayLogoOnPublications: action.payload } : state,
        setLogoUrl: (state, action: PayloadAction<string | undefined>) =>
            state ? { ...state, logoUrl: action.payload } : state,
        setGroupement: (state, action: PayloadAction<Groupement | undefined>) =>
            state ? { ...state, groupement: action.payload } : state,
    },
});

export const { setUser, logout, setAutoPubNf, setLogoDisplay, setLogoUrl, setGroupement } =
    userSlice.actions;
export default userSlice.reducer;
